import FilterBoxList from './FilterBoxList';

export default function CountyFilter({
	counties,
	isInsidePopup = false,
	filters,
	setFilters
}) {
	return isInsidePopup ? (
		<div class="flex-grow relative">
			<div class="absolute w-full h-full inset-0 overflow-y-scroll">
				<FilterBoxList
					items={counties}
					isInsidePopup={true}
					filters={filters}
					setFilters={setFilters}
					filterKey="countyTerms"
				/>
			</div>
		</div>
	) : (
		<FilterBoxList
			items={counties}
			filters={filters}
			setFilters={setFilters}
			filterKey="countyTerms"
		/>
	);
}
